import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { JourneysState, ProductJourneyDashboardAreaFullResponse } from '../types';
import { ContentVideoPlayer } from 'features/contents';
import { Card } from 'app/types/cards/Card';

const initialState: JourneysState = {
  journeyAreaDetails: undefined!,
  journeyVideoPlayer: undefined!,
  journeyCards: [],
};

const journeySlice = createSlice({
  name: 'journeys',
  initialState,
  reducers: {
    setJourneyAreaDetailsAction(state, action: PayloadAction<ProductJourneyDashboardAreaFullResponse>) {
      state.journeyAreaDetails = action.payload;
    },

    setJourneyVideoPlayerAction(state, action: PayloadAction<ContentVideoPlayer>) {
      state.journeyVideoPlayer = action.payload;
    },

    setJourneyCardsAction(state, action: PayloadAction<Card[]>) {
      state.journeyCards = action.payload;
    },
  },
});

export const { setJourneyAreaDetailsAction, setJourneyVideoPlayerAction, setJourneyCardsAction } = journeySlice.actions;

export const getJourneys = (state: RootState): JourneysState => state.journeys;

export default journeySlice.reducer;
